import { axiosPostAuthorize } from "../AxiosRequests";
import { GetMetabaseIframeUrl } from "../ApiEndPoints";

export default class MetabaseServices {
  async getMetabaseIframeUrl(request) {
    return axiosPostAuthorize(GetMetabaseIframeUrl, request);
  }
}
